
import { isEmpty } from 'lodash-es';
import Binding from "../entrypoints/src/admin/utilities/binding";
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
		this.$saveButton = this.element.querySelector('button[type="submit"]');
		this.$paymentModule = this.element.querySelector('#payment-module');
		this.$pricing = this.element.querySelector('#pricing');
		this.pricingPlan = +this.$pricing.dataset.corePrice;
		this.pricing = this.humanizedPrice(this.pricingPlan);
		new Binding({ object: this, property: 'pricing' }).addBinding(this.$pricing, "innerHTML");

		this.element.querySelectorAll('.card-extra-service .collapse').forEach(($el) => {
			$el.addEventListener('click', (ev) => {
				ev.preventDefault();
				ev.stopPropagation();

				if (ev.path.length > 0 && ev.path[0].nodeName === 'A')
					return window.open(ev.path[0].href);
			});
		});

		this.element.querySelectorAll('.card-extra-service').forEach(($el) => {
			$el.querySelector('input[type="checkbox"]').addEventListener('change', (ev) => this.updatePricing($el));
			$el.addEventListener('click', (ev) => this.updateCollapse($el));
			this.updateCollapse($el);
		});

		this.$paymentModule.querySelectorAll('input, textarea, select').forEach(($el) => {
			$el.addEventListener('change', () => this.validateRequiredFields() );
		});

		this.$saveButton.addEventListener('click', (ev) => {
			if (this.$saveButton.classList.contains('disabled')) {
				ev.preventDefault();

				Swal.fire({
					title: 'Atenção',
					text: 'Preencha os campos destacados com asterisco corretamente para continuar'
				});
			}
		});

		this.validateRequiredFields();
	}

	updateCollapse($el) {
		let status = $el.querySelector('input[type="checkbox"]').checked ? 'show' : 'hide';
		$($el.querySelector('.collapse'))
			.collapse(status)
			.on('shown.bs.collapse', () => this.validateRequiredFields())
			.on('hidden.bs.collapse', () => this.validateRequiredFields());
	}

	validateRequiredFields() {
		if (!this.$paymentModule.classList.contains('in'))
			return this.$saveButton.classList.toggle('disabled', false);

		let valid = [...this.element.querySelectorAll('input[type="text"]')].reduce((accumulator, current) => { return accumulator &= !isEmpty(current.value) }, true);
		this.$saveButton.classList.toggle('disabled', !valid);
	}

	updatePricing($label) {
		if (!$label.dataset.servicePrice)
			return;

		this.pricingPlan = this.pricingPlan + ($label.querySelector('input[type="checkbox"]').checked ? +$label.dataset.servicePrice : -$label.dataset.servicePrice);
		this.pricing = this.humanizedPrice(this.pricingPlan);
	}

	humanizedPrice(value) {
		return (value / 100).toFixed(2).toString().replace(',', '').replace('.', ',');
	}
}
